<template>
    <div>
        <!-- DIALOGS -->  
        <SelectionRequiredDialog /> 
        <DeletionDialog context="SelectedLabelProjects" />	
        
        <!-- LIST PAGE -->
        <BaseListPage
            headline="lang_LABEL_PROJECTS"
            :context="context"
            :alvqa="alvqa"
            :stickyHeader="true"
        >
            <template v-slot:dataTable>
                <!-- DATA TABLE -->
                <BaseDataTableList
                    :headers="headers"
                    :context="context"
                    :alvqa="alvqa"
                    :hasServerSideSorting='true'
                    :stickyTopSlot="true"
                >
                    <!-- TOP SLOT -->
                    <template v-slot:topSlot>
                        <ReleasesTopSlot />
                    </template>

                    <!-- TABLE -->
                    <template v-slot:body="{ item }">
                        <ExpandIcon 
							:isExpanded="item.isExpanded" 
							:alvqa="alvqa + '-list-row-' + item.item.alvId + '-icon-expand'"
						/>
                        <td class="ellipsis">
							{{ item.item.title }}
						</td>
                        <td class="ellipsis">
							{{ item.item.alvId }}
						</td>
                    </template>

                    <!-- READ ONLY -->
                    <template v-slot:expandSlot>
                        <LabelProjectsReadOnly />
                    </template>
                </BaseDataTableList>
            </template>
        </BaseListPage>
    </div>
</template>

<script>
import BaseListPage from '@/components/_base/BaseListPage'
import BaseDataTableList from '@/components/_base/BaseDataTableList'
import ExpandIcon from '@/components/_buttons/ExpandIcon'

import LabelProjectsReadOnly from './_readonly/LabelProjectsReadOnly'
import ReleasesTopSlot from './LabelProjectsTopSlot'

import SelectionRequiredDialog from '@/components/_dialogs/SelectionRequiredDialog'
import DeletionDialog from '@/components/_dialogs/DeletionDialog'

export default {
    name: 'LabelProjectsList',
    components: {
        BaseListPage,
        BaseDataTableList,
        ExpandIcon,
        
        LabelProjectsReadOnly,
        ReleasesTopSlot,

        SelectionRequiredDialog,
        DeletionDialog,
    },
    data() {
        return {
            context: 'LabelProjects',
            alvqa: 'label-projects'
        }
    },
    computed: {
        headers() {
            return [
                {
					text: '', 
					value: 'data-table-select', 
					align: 'center',
                    sortable: false,
					width: "60px"
				},
				{
					text: '', 
					value: 'data-table-expand',
					align: 'center', 
					width: "48px",
                    sortable: false,
					class: 'text-no-wrap'
                },
                {
                    text: this.$t('lang_LABEL_PROJECTS_CAPTION_TITLE'), 
                    value: 'title', 
                    align: 'left', 
                    sortable: true,
                    class: 'text-no-wrap'
                },
                {
                    text: this.$t('lang_GENERIC_CAPTION_ALVID'), 
                    value: 'alvId', 
                    align: 'left',
                    sortable: true,
                    class: 'text-no-wrap'
                },
				{
					text: '', 
					value: 'editForm',
					align: 'right',
					sortable: false,
                    width: "70px",
                    class: 'text-no-wrap'
				}
            ]
        }
    }
}
</script>